import Modal, { ModalButtonStyle } from "@components/Modal";
import closeIcon from 'url:@icon/close.svg';

import './index.scss';
import EventsController, { Event } from "@data/controller/EventsController";
import { useEffect, useState } from "react";
import LoadingIndicator from "@components/LoadingIndicator";
import { useAuth } from "@auth/AuthProvider";
import SuccessView from "@components/SuccessView";
import ErrorView from "@components/ErrorView";

export default function WaiverReminderMailModal(props: {
  event: Event,
  isOpen: boolean,
  close: () => void
}) {
  const auth = useAuth();

  const [showProgressIndicator, setShowProgressIndicator] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [totalSent, setTotalSent] = useState(0);
  const [totalFailed, setTotalFailed] = useState(0);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!props.isOpen) return;
    setError(null);
    setShowProgressIndicator(false);
    setShowSuccess(false);
  }, [props.isOpen]);

  const sendWaiverReminder = async () => {
    setShowProgressIndicator(true);

    try {
      const response = await EventsController.sendWaiverReminderEmails(props.event.churchID, props.event.id, auth);
      if (response.error) {
        setError(response.error);
        return;
      }

      setTotalSent(response.body?.totalSent ?? 0);
      setTotalFailed(response.body?.totalFailed ?? 0);
      setShowSuccess(true);
    } catch (e: any) {
      setError(e);
    } finally {
      setShowProgressIndicator(false);
    }
  }

  const closeButton = <a className="close"
    href="#"
    onClick={(e) => {
      e.preventDefault();
      props.close()
    }}>
    <img className="icon" src={closeIcon} alt="Close icon" />
  </a>;

  const hideFooterButtons = showProgressIndicator || showSuccess || error !== null;

  return <Modal id="waiver-reminder-modal"
    isOpen={props.isOpen}
    footerButtons={hideFooterButtons ? [] : [
      {
        title: 'Send Reminder Email',
        style: ModalButtonStyle.FILLED,
        onClick: () => {
          sendWaiverReminder();
        }
      }
    ]}>
    <div style={{
      paddingTop: 32
    }}>
      {showProgressIndicator ? <LoadingIndicator fullScreen={false} /> : <>
        {closeButton}

        {showSuccess ? <SuccessView title="Reminders Sent" description={`Successfully sent ${totalSent} reminder email${totalSent == 1 ? '' : 's'}.` + (totalFailed > 0 ? ` (${totalFailed} failed to send. Please contact support.)` : "")} /> : null}
        {error && <ErrorView error={error} showButton={false} />}

        {!error && !showSuccess ? <>
          <h3>Confirm Waiver Reminder Email</h3>
          <p>Would you like to send a reminder to all attendees who have not completed their waivers? This action cannot be undone.</p>
        </> : null}
      </>}
    </div>
  </Modal>
}